import React, { useEffect } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Divider, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import CommentDrawer from '../Common/Drawer';
import { toast } from 'react-toastify';
import { encrypt } from '../../utils/helper';
import PasswordVisibility from '../Common/PasswordVisibility';
import { createInstagramAC } from '../../store/cookieSlice';

export default function InstagramForm({ page, setPage, getCookies, title, cookieModal, setCookieModal, selectedDomain = null }) {
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = React.useState(false);

    const validationSchema = Yup.object({
        email: Yup.string()
            .required("Email is required")
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                "Enter a valid email address"
            ),
        password: Yup.string()
            .required("Password is required"),
    });

    const formik = useFormik({
        initialValues: {
            email: "",
            password: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setCookieModal(false);
            const toastId = toast.loading("We're processing the account credentials. This may take a few moments");
            try {
                if (selectedDomain) {

                } else {
                    const data = { ...values, password: encrypt(values.password), integration: "instagram" };
                    await dispatch(createInstagramAC(data)).then(() => {
                        if (page) {
                            setPage(0)
                        }
                        getCookies()
                        toast.update(toastId, {
                            render: "Will take some time to complete the process",
                            type: "warning",
                            isLoading: false,
                            autoClose: 3000,
                        });
                    })
                }

                // toast.success("Action completed successfully", { toastId });
            } catch (error) {
                // toast.error("Something went wrong. Please try again.", { toastId });
                toast.update(toastId, {
                    render: "Something went wrong. Please try again.",
                    type: "error",
                    isLoading: false,
                    autoClose: 3000,
                });
            } finally {
                toast.dismiss(toastId); // Dismiss toast when done

            }
        }
    })


    useEffect(() => {
        if (cookieModal) {
            formik.resetForm();
        }
    }, [cookieModal]); // Reset form only when modal opens

    return (
        <CommentDrawer open={cookieModal} setOpen={setCookieModal}>
            <Box className="p-3 position-relative h-100">
                <form onSubmit={formik.handleSubmit}>
                    <Typography variant="h6" gutterBottom>
                        {title}
                    </Typography>
                    <Divider />
                    <TextField
                        fullWidth
                        required
                        id="email"
                        name="email"
                        type="email"
                        label="Instagram Email"
                        margin="normal"
                        variant="outlined"
                        placeholder="Enter Instagram Email"
                        value={formik.values.email}
                        // onChange={formik.handleChange}
                        onChange={(e) => {
                            const lowerCaseEmail = e.target.value.toLowerCase();
                            formik.setFieldValue("email", lowerCaseEmail);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email && formik.errors.email}
                    />
                    <TextField
                        fullWidth
                        required
                        id="password"
                        name="password"
                        label="Instagram Password"
                        margin="normal"
                        type={showPassword ? "text" : "password"}
                        variant="outlined"
                        placeholder="Enter Instagram Password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.password && Boolean(formik.errors.password)}
                        helperText={formik.touched.password && formik.errors.password}
                        InputProps={{
                            endAdornment: (
                                <PasswordVisibility
                                    showPassword={showPassword}
                                    onToggle={() => setShowPassword((prev) => !prev)}
                                />
                            )
                        }}
                    />
                    <Box className="drawer-footer m-3">
                        <Button
                            type="button"
                            variant="outlined"
                            color="primary"
                            onClick={() => setCookieModal(false)}
                            className="mt-2 mr-2"
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className="mt-2"
                            disabled={formik.isSubmitting || (selectedDomain ? !formik.isValid : !(formik.dirty && formik.isValid))}
                        >
                            Save
                        </Button>
                    </Box>
                </form>
            </Box>
        </CommentDrawer>
    );
}